// extracted by mini-css-extract-plugin
export default {"outerDiv":"verticals-page_outerDiv__kCY-9","addBtn":"verticals-page_addBtn__nmpN+"};